import { metUrl } from "./metMainSite";

export interface NavChild {
  text: string;
  url: string;
  internal?: boolean;
}

export interface NavItem {
  id: string;
  text: string;
  url?: string;
  internal?: boolean;
  children?: NavChild[];
}

// MET2-2893: header destinations mapped to the canonical paths in
// MetOpera_MENU_URLMAP_5-7-26.xlsx. The spreadsheet expresses paths against the
// Met marketing site, so those entries are built with metUrl() and pick up the
// per-environment host from REACT_APP_MET_MAIN_SITE_URL (see config/metMainSite).
// Non-main-site destinations (ondemand.metopera.org, plannedgiving,
// jobs.lever.co, metoperashop) are used verbatim from the sheet.
export const headerConfig: NavItem[] = [
  // MET2-2832: Tickets now has a dropdown
  {
    id: "tickets",
    text: "Tickets",
    children: [
      { text: "Calendar", url: metUrl("/calendar/") },
      { text: "Explore By Opera", url: metUrl("/season/tickets/explore-by-opera/") },
      // MET2-2893: distinct destinations (were both /season/tickets/)
      { text: "Subscriptions & Packages", url: metUrl("/season/tickets/subscriptions-programs/") },
      { text: "Discount Programs", url: metUrl("/season/tickets/discount-programs/") },
      { text: "Official Ticket Policy", url: metUrl("/season/tickets/official-ticket-policy/") },
      { text: "Gift Cards", url: metUrl("/gift-certificates/") },
      { text: "American Ballet Theatre", url: metUrl("/season/tickets/2026-abt/") },
    ],
  },
  // MET2-2836: In Cinemas top-level (text corrected to match staging)
  {
    id: "in-cinema",
    text: "In Cinemas",
    url: metUrl("/season/in-cinemas/"),
  },
  // MET2-2828: On Demand now has a dropdown
  {
    id: "on-demand",
    text: "On Demand",
    children: [
      { text: "Met Opera On Demand", url: "/", internal: true },
      { text: "Videos", url: metUrl("/learn/videos/") },
      { text: "Live Audio Streams", url: "https://ondemand.metopera.org/radio/a7baf155-0df5-5c48-a287-41b89abd0fdd" },
      // MET2-2893: Radio maps to the metopera.org season radio page per the
      // URL map (was the internal /radio SPA route).
      { text: "Radio", url: metUrl("/season/radio/") },
      { text: "Podcasts", url: metUrl("/discover/podcasts/") },
    ],
  },
  {
    id: "visit",
    text: "Visit",
    children: [
      { text: "Getting Here", url: metUrl("/visit/getting-here/") },
      { text: "Accessibility", url: metUrl("/visit/accessibility/") },
      { text: "Dining At The Met", url: metUrl("/visit/dining-at-the-met/") },
      { text: "Tours", url: metUrl("/visit/tours/") },
      { text: "What To Expect", url: metUrl("/visit/what-to-expect/") },
      // MET2-2833: Seating Chart — URL from staging
      { text: "Seating Chart", url: metUrl("/season/tickets/seat-maps/") },
      // MET2-2893: new menu item per the URL map
      { text: "VIP Concierge Services", url: metUrl("/season/tickets/vip-concierge-services/") },
    ],
  },
  // MET2-2829: Discover renamed to Learn, items restructured
  {
    id: "learn",
    text: "Learn",
    children: [
      { text: "Talks & Events", url: metUrl("/discover/talks-and-events/") },
      { text: "Articles", url: metUrl("/discover/articles/") },
      // MET2-2893: corrected paths per URL map
      { text: "Education", url: metUrl("/learn/education/") },
      { text: "Archives", url: metUrl("/discover/archive/") },
      { text: "Exhibitions", url: metUrl("/visit/exhibitions/") },
    ],
  },
  {
    id: "support",
    text: "Support",
    children: [
      // MET2-2893: Give Now / Become a Member move under /support/ per URL map
      { text: "Give Now", url: metUrl("/support/quick-donate/") },
      { text: "Become a Member", url: metUrl("/support/become-a-member/") },
      { text: "Special Funds", url: metUrl("/support/make-a-gift/") },
      { text: "Corporate Partnership", url: metUrl("/support/corporate-partnership/") },
      { text: "Leave A Legacy", url: "https://plannedgiving.metopera.org/" },
    ],
  },
  {
    id: "about",
    text: "About",
    children: [
      // MET2-2893: corrected paths per URL map
      { text: "Our Story", url: metUrl("/about/our-story/") },
      { text: "Press Releases", url: metUrl("/about/press-release/") },
      { text: "Who We Are", url: metUrl("/about/who-we-are/") },
      { text: "FAQ", url: metUrl("/about/faq/") },
      { text: "Jobs", url: "https://jobs.lever.co/metopera" },
      { text: "Internships", url: metUrl("/about/internships/") },
      { text: "Auditions", url: metUrl("/about/auditions/") },
      { text: "Contact Us", url: metUrl("/about/contact-us/") },
      { text: "Annual Reports", url: metUrl("/about/annual-reports/") },
    ],
  },
  {
    id: "shop",
    text: "Shop",
    url: "https://www.metoperashop.org/",
  },
];
